import { CardContentHeaderActions } from "./CardContentHeaderActions"
import { CardContentHeaderProps } from "../../props/CardContentHeaderProps";
import { CardContentHeaderIcons } from "./CardContentHeaderIcons";
import { CardContentHeaderTitle } from "./CardContentHeaderTitle";

export const CardContentHeader = ({
    title = "",
    subTitle = "",
    subTitleClassName = "",
    icons,
    iconSize,
    borderColor = "var(--card-border)",
    backgroundColor = "var(--card-body-bg)",
    actions = [],
    actionsDisplay = "dropdown",
    adjustedColor = "",
    adjustedIconColor = "",
    cardService,
    dispatcherService,
    onItemClick,
    isDirty = false,
    showDeleteButtonOnMobile = false,
    clipboardText = "",
    truncateSubTitle = true
}:CardContentHeaderProps) => {
    
    return (
        <header className="crd-content-header">
            <CardContentHeaderTitle
                cardService={cardService}
                title={title}
                subTitle={subTitle}
                subTitleClassName={subTitleClassName}
                dispatcherService={dispatcherService}
                clipboardText={clipboardText}
                truncateSubTitle={truncateSubTitle}
            />
            <CardContentHeaderIcons
                icons={icons}
                iconSize={iconSize}
                adjustedColor={adjustedColor}
                isDirty={isDirty}
            />
            <CardContentHeaderActions
                cardService={cardService}
                actions={actions}
                actionsDisplay={actionsDisplay}
                borderColor={borderColor}
                backgroundColor={backgroundColor}
                adjustedIconColor={adjustedIconColor}
                dispatcherService={dispatcherService}
                showDeleteButtonOnMobile={showDeleteButtonOnMobile}
                onItemClick={onItemClick}
            />
        </header>
    )
}
